import React from 'react';
import { Text, View, Pressable, Keyboard, StyleSheet, ActivityIndicator } from 'react-native';

import { COLOR, FONT, FONT_SIZE, THEME } from '../../constants/styles';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  createEvent,
  updateEvent,
  deleteEvent,
  uploadFiles,
  setUploadStatePending,
  clearUploadState,
  clearEventDetails,
  resetState,
} from './actions';

import upsertOperationEnum from '../../constants/eventUpsertOperationEnum';
import { getCurrentCase, getEditingCase, getCaseById } from '../cases/selector';
import {
  uiFormattedEditingEvent,
  getEventNotes,
  getFileUploadStatusForEditingEvent,
} from './selector';
import { PENDING, REQUESTING, SUCCESS, FAILED } from '../../actions/statusTypes';

import {
  OPComponent,
  Container,
  NavBar,
  I18n,
  FormInput,
  AttachmentsInput,
  Utils,
  Navigation,
  FormHelpers,
  RemoveButton,
} from '../components';

import EventSettings from './event_form_settings';

function isEditableEventType(typeName) {
  return true;
  // return (
  //   typeName.toLowerCase() !== EVENT_TYPE_AIRFORCE_DEPLOYMENT.toLowerCase() &&
  //   typeName.toLowerCase() !== EVENT_TYPE_IMMUNIZATION.toLowerCase() &&
  //   typeName.toLowerCase() !== EVENT_TYPE_DRHA.toLowerCase() &&
  //   typeName.toLowerCase() !== EVENT_TYPE_LAB.toLowerCase() &&
  //   typeName.toLowerCase() !== EVENT_TYPE_AUDIOGRAM.toLowerCase() &&
  //   typeName.toLowerCase() !== EVENT_TYPE_PHA_FLY.toLowerCase() &&
  //   typeName.toLowerCase() !== EVENT_TYPE_PHA.toLowerCase()
  // );
}

class EventForm extends OPComponent {
  static options(passProps) {
    return {
      topBar: {
        rightButtons: [NavBar.buttons.save],
        leftButtons: [NavBar.buttons.cancel],
      },
    };
  }

  constructor(props) {
    super(props);

    const presets = props.presets || {};

    if (props.editingEvent) {
      this.state = {
        title: props.editingEvent.eventName,
        notes: props.editingEventNotes,
        files: props.editingEvent.files.slice(),
        startDate: new Date(props.instanceStart || props.editingEvent.startDate),
        exceptionDate: new Date(props.instanceStart || props.editingEvent.startDate),
        endDate: new Date(props.instanceEnd || props.editingEvent.endDate),
        allDay: props.editingEvent.allDay,
        repeat: props.editingEvent.repeat || { repeat: -1 },
        reminder: props.editingEvent.reminder || -1,
        phone: props.editingEvent.phone,
        locationString:
          props.editingEvent.locationString || props.editingEvent.location?.locationName || null,
        extraData: props.editingEvent.extraData,
        eventId: props.editingEvent.eventId,
        eventTypeName: props.editingEvent.eventTypeName,
        timeZone: props.editingEvent.timeZone,
        assignee: props.editingEvent.assignee,
        allowEditingType: isEditableEventType(props.editingEvent.eventTypeName),
      };
      this.origRepeat = this.state.repeat;
    } else {
      this.state = {
        title: null,
        notes: null,
        files: [],
        startDate: null,
        endDate: null,
        allDay: false,
        repeat: { repeat: -1 },
        reminder: -1,
        locationString: null,
        phone: null,
        extraData: {},
        eventTypeName: I18n.t('calendar.eventTypeOther'),
        assignee: null,
        timeZone: props.currentCaseObj?.timeZone,
        allowEditingType: true,
        ...presets,
      };
    }
    this.state.newFiles = [];
    this.state.removedFiles = [];

    this._uploadingFiles = false;
    this._isNew = !props.editingEvent;

    this.titleInputRef = React.createRef();
  }

  navigationButtonPressed = ({ buttonId }) => {
    if (this.props.status === REQUESTING || this.props.uploadStatus === REQUESTING) return;

    if (NavBar.handleButtonPress2(buttonId, this)) return;
  };

  componentDidMount() {
    Utils.trackScreen('Calendar', 'Event Form');
    this.props.actions.clearUploadState(this.props.eventId);

    Navigation.registerForButtonEvents(this);
  }

  componentWillUnmount() {
    Navigation.unRegisterForButtonEvents(this);

    this.props.actions.resetState();
    this.props.actions.clearUploadState(this.props.eventId);

    // if this is a new event, or we've deleted an event
    if (this._isNew || !this.props.editingEvent) {
      this.props.actions.clearEventDetails();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.status === SUCCESS && prevProps.status !== SUCCESS) {
      if (this._addedEvent) {
        this.props.onEventAdd && this.props.onEventAdd(this._addedEvent);
        this._addedEvent = null;
      }

      if (this.state.newFiles.length) {
        this.uploadFiles();
      } else {
        this._closeForm();
      }
    }

    if (this.props.uploadStatus === FAILED && prevProps.uploadStatus !== FAILED) {
      this._uploadingFiles = false;
    }

    if (this.props.uploadStatus === SUCCESS && prevProps.uploadStatus !== SUCCESS) {
      this._closeForm();
    }

    if (this.props.errorMessage && this.props.errorMessage.message !== this.state.errorMessage) {
      this.setState({ errorMessage: this.props.errorMessage.message });
    }
  }

  _closeForm() {
    Keyboard.dismiss();
    Utils.trackEvent('Action', 'Tap', 'Close event form');
    // dismiss the form and event details screen if open because event details screen doesnt
    // update correctly after editing event
    Navigation.dismissAllModals();
  }

  _showDeleteActionSheet() {
    const actionSheet = this._containerRef && this._containerRef.getActionSheetRef();
    if (!actionSheet) return;

    const options = [
      I18n.t('calendar.deleteThisEventOnly'),
      I18n.t('calendar.deleteFutureEvents'),
      I18n.t('cancel'),
    ];
    const cancelButtonIndex = options.length - 1;
    const title = I18n.t('calendar.repeatingEventTitle');

    actionSheet.showActionSheetWithOptions(
      {
        options,
        cancelButtonIndex,
        title,
      },
      this.deleteEvent
    );
  }
  checkOperationAndDelete = () => {
    if (this.state.eventId && this.origRepeat.repeat !== -1) {
      this._showDeleteActionSheet();
    } else {
      this.deleteEvent();
    }
  };
  deleteEvent = (operationNum = null) => {
    Utils.trackEvent('Action', 'Tap', 'Delete Event');

    let operation;
    if (operationNum != null) {
      if (operationNum === 2) return;
      operation = operationNum
        ? upsertOperationEnum.DELETE_RECURRING_FUTURE_EVENTS
        : upsertOperationEnum.DELETE_RECURRING_SINGLE_EVENT;
    }

    this.props.actions.deleteEvent(
      this.state.eventId,
      this.props.currentCaseObj.caseId,
      operation,
      this.state.exceptionDate
    );
  };

  repeatEndIsChanging(end1, end2) {
    if (!end1 && !end2) return false;
    if (!end1 && !!end2) return true;
    if (!!end1 && !end2) return true;
    if (end1.getTime() !== end2.getTime()) return true;
    return false;
  }

  _showSaveActionSheet() {
    const actionSheet = this._containerRef && this._containerRef.getActionSheetRef();
    if (!actionSheet) return;

    const options = [
      I18n.t('calendar.saveThisEventOnly'),
      I18n.t('calendar.saveFutureEvents'),
      I18n.t('cancel'),
    ];

    const cancelButtonIndex = options.length - 1;
    const title = I18n.t('calendar.repeatingEventTitle');

    actionSheet.showActionSheetWithOptions(
      {
        options,
        cancelButtonIndex,
        title,
      },
      this.submit
    );
  }
  onSave = () => {
    Utils.trackEvent('Action', 'Tap', 'Save Event');

    const fieldsToValidate = [this.titleInputRef];
    const formIsValid = FormHelpers.validateFields(
      fieldsToValidate.map((fieldRef) => fieldRef.current).filter((ref) => !!ref)
    );
    if (!formIsValid) {
      this.setState({ errorMessage: I18n.t('form.pleaseResolveErrors') });
      return;
    }

    if (this.state.eventId && this.origRepeat.repeat !== -1) {
      let isChangingRepeat =
        this.origRepeat.repeat !== this.state.repeat.repeat ||
        this.repeatEndIsChanging(this.origRepeat.endDate, this.state.repeat.endDate);

      if (!isChangingRepeat) {
        this._showSaveActionSheet();
      } else {
        this.submit(1);
      }
    } else {
      this.submit();
    }
  };
  submit = (operationNum = null) => {
    let operation;
    if (operationNum != null) {
      if (operationNum === 2) return;
      operation = operationNum
        ? upsertOperationEnum.UPDATE_RECURRING_FUTURE_EVENTS
        : upsertOperationEnum.UPDATE_RECURRING_SINGLE_EVENT;
    }

    let eventObj = {
      eventName: this.state.title,
      notes: this.state.notes,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      allDay: this.state.allDay,
      eventId: this.state.eventId,
      repeat: Object.assign({}, this.state.repeat),
      reminder: this.state.reminder,
      locationString: this.state.locationString,
      phone: this.state.phone,
      extraData: this.state.extraData,
      eventTypeName: this.state.eventTypeName,
      timeZone: this.state.timeZone,
      assignee: this.state.assignee,
    };

    // console.info('saving eventObj', eventObj);
    // return;

    if (this.state.eventId) {
      this.props.actions.updateEvent(
        eventObj,
        this.props.currentCaseObj.caseId,
        this.state.eventId,
        operation,
        this.state.exceptionDate
      );
    } else {
      this._addedEvent = eventObj;
      this.props.actions.createEvent(eventObj, this.props.currentCaseObj.caseId);
    }
  };

  uploadFiles() {
    if (this._uploadingFiles) return;
    if (!this.state.newFiles || !this.state.newFiles.length) return;

    this._uploadingFiles = true;
    this.props.actions.uploadFiles(this.props.eventId, this.state.newFiles);
  }

  handleChangeText(stateAttrName, text) {
    this.setState({
      [stateAttrName]: text,
    });
  }

  handleEventTypeName = (eventTypeName) => {
    this.setState({ eventTypeName });
  };
  handleLocationString = (locationString) => {
    this.setState({ locationString });
  };
  handlePhone = (phone) => {
    this.setState({ phone });
  };
  handleDateTime = ({ startDate, endDate, allDay, timeZone }) => {
    this.setState({ startDate, endDate, allDay, timeZone });
  };
  handleStartDate = (startDate) => {
    this.setState({ startDate });
  };
  handleEndDate = (endDate) => {
    this.setState({ endDate });
  };
  handleAllDay = (allDay) => {
    this.setState({ allDay });
  };
  handleTimeZone = (timeZone) => {
    this.setState({ timeZone });
  };

  handleRepeat = (repeat) => {
    this.setState({
      repeat: { ...repeat },
    });
  };
  handleReminder = (reminder) => {
    this.setState({ reminder });
  };
  handleAssignee = (assignee) => {
    this.setState({ assignee });
  };

  handleAddAttachment = (attachment) => {
    this.setState({ newFiles: this.state.newFiles.concat(attachment) }, () => {
      this.props.actions.setUploadStatePending(this.props.eventId);
    });
  };
  handleRemoveAttachment = (attachment) => {
    let { newFiles, removedFiles } = this.state;
    let i = newFiles.indexOf(attachment);
    if (i >= 0) {
      newFiles.splice(i, 1);
    } else {
      removedFiles.push(attachment);
    }
    // else add to remove collection to send to action
    this.setState({ newFiles, removedFiles }, () => {
      this.props.actions.setUploadStatePending(this.props.eventId);
    });
  };

  isPast(e) {
    return e.startDate < new Date();
  }

  render() {
    const props = this.props;
    if (!this.props.currentCaseObj) {
      return <View style={THEME.containerAlt} />;
    } else {
      // dont allow delete of employer events
      const canDelete =
        !!props.editingEvent &&
        !props.editingEvent.masterEventId &&
        !this.isPast(props.editingEvent);
      return (
        <Container
          ref={(ref) => (this._containerRef = ref)}
          style={THEME.containerAlt}
          scrollView={true}
          actionSheet={true}
          renderActivityOverlay={this.props.status === 'requesting'}
          errorMessage={this.state.errorMessage}
        >
          <View style={styles.header}>
            <Text style={styles.caseNameText}>{this.props.currentCaseObj.name}</Text>

            <FormInput
              ref={this.titleInputRef}
              value={this.state.title}
              required={true}
              label={I18n.t('calendar.eventName')}
              returnKeyType="done"
              onChangeText={(text) => {
                this.handleChangeText('title', text);
              }}
            />

            <FormInput
              value={this.state.locationString}
              label={I18n.t('calendar.location')}
              returnKeyType="done"
              onChangeText={(text) => {
                this.handleChangeText('locationString', text);
              }}
            />
          </View>

          <View style={styles.detailsContainer}>
            <FormInput
              value={this.state.notes}
              label={I18n.ac('calendar.notes')}
              returnKeyType="default"
              autoCapitalize="sentences"
              multiline={true}
              numberOfLines={3}
              onChangeText={(text) => {
                this.handleChangeText('notes', text);
              }}
            />

            <AttachmentsInput
              attachments={this.state.files}
              newAttachments={this.state.newFiles}
              removedAttachments={this.state.removedFiles}
              onAdd={this.handleAddAttachment}
              onRemove={this.handleRemoveAttachment}
            />

            {this.props.uploadStatus === REQUESTING && (
              <View style={styles.uploadIndicatorContainer}>
                <ActivityIndicator animating={true} size="small" color="gray" style={{}} />
                <Text style={THEME.clarifyingNote}> {I18n.t('form.uploadingFiles')}</Text>
              </View>
            )}
            {!!this.props.uploadErrorMessage && (
              <Text style={THEME.errorMessage}>
                {I18n.t('form.uploadFailed')} {this.props.uploadErrorMessage}
              </Text>
            )}
          </View>

          <View style={styles.settingsContainer}>
            <EventSettings
              componentId={this.props.componentId}
              eventTypeName={this.state.eventTypeName}
              allowEditingType={this.state.allowEditingType}
              phone={this.state.phone}
              startDate={this.state.startDate}
              endDate={this.state.endDate}
              selectedDate={this.props.selectedDate}
              allDay={this.state.allDay}
              timeZone={this.state.timeZone}
              reminder={this.state.reminder}
              repeat={this.state.repeat}
              assignee={this.props.followers[this.state.assignee]}
              onEventTypeName={this.handleEventTypeName}
              onPhone={this.handlePhone}
              onDateTime={this.handleDateTime}
              onStartDate={this.handleStartDate}
              onAllDay={this.handleAllDay}
              onTimeZone={this.handleTimeZone}
              onEndDate={this.handleEndDate}
              onRepeat={this.handleRepeat}
              onReminder={this.handleReminder}
              onAssignee={this.handleAssignee}
            />
          </View>

          {canDelete && (
            <Pressable style={styles.deleteEventButton} onPress={this.checkOperationAndDelete}>
              <RemoveButton />
              <Text style={styles.deleteEventButtonText}>
                {I18n.ac('calendar.deleteThisEvent')}
              </Text>
            </Pressable>
          )}
        </Container>
      );
    }
  }
}

const styles = StyleSheet.create({
  header: {
    paddingHorizontal: 25,
    paddingVertical: 20,
    backgroundColor: COLOR.altContrast,
  },
  detailsContainer: {
    paddingHorizontal: 25,
    paddingVertical: 20,
    backgroundColor: COLOR.contrast,
  },
  caseNameText: {
    ...FONT.medium,
    fontSize: FONT_SIZE.regular,
    color: COLOR.text,
    textAlign: 'center',
    marginBottom: 20,
  },
  settingsContainer: {
    backgroundColor: COLOR.contrast,
  },
  settingRow: {
    paddingHorizontal: 25,
    flexDirection: 'row',
    alignItems: 'center',
    height: 65,
    borderTopWidth: 1,
    borderColor: COLOR.accent,
  },
  settingIcon: {
    width: 16.5,
    height: 16,
  },
  settingText: {
    flex: 1,
    ...FONT.regular,
    fontSize: FONT_SIZE.large,
    color: COLOR.textLight,
    marginLeft: 20,
  },
  settingTextValue: {
    ...FONT.regular,
    fontSize: FONT_SIZE.small,
    color: COLOR.textLight,
    marginRight: 20,
    textAlign: 'right',
  },
  arrowIcon: THEME.arrowIcon,
  deleteEventButton: {
    padding: 25,
    flexDirection: 'row',
    alignItems: 'center',
  },
  deleteEventButtonText: {
    ...FONT.semibold,
    fontSize: FONT_SIZE.regular,
    color: COLOR.emphasis,
    marginLeft: 10,
  },
  uploadIndicatorContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
});

function mapStateToProps(state, ownProps) {
  const editingEvent = uiFormattedEditingEvent(state);
  const caseId = (!!editingEvent && editingEvent.caseId) || ownProps.caseId;
  const currentCaseObj = caseId
    ? getCaseById(state, { caseId })
    : getEditingCase(state) || getCurrentCase(state);

  return {
    status: state.screens.calendar.status,
    errorMessage: state.screens.calendar.errorMessage,
    currentCaseObj,
    editingEvent,
    editingEventNotes: getEventNotes(state),
    eventId: state.screens.calendar.editingEventId,
    followers: state.entities.followers,
    uploadStatus: getFileUploadStatusForEditingEvent(state).status,
    uploadErrorMessage: getFileUploadStatusForEditingEvent(state).errorMessage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        createEvent,
        updateEvent,
        deleteEvent,
        resetState,
        uploadFiles,
        setUploadStatePending,
        clearUploadState,
        clearEventDetails,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EventForm);
